// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const LinerWearContainer = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  border-radius: 4px;
  width: 100%;
  height: 100%;
  flex: 1;
  min-width: 0;
  flex-direction: column;
`;

export const LinerWearContent = styled.div`
  display: flex;
  align-items: flex-end;
  padding: 1rem 1rem 1rem 1.5rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
`;

export const MobileContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  padding: 0.75rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  display: flex;
  flex: 1;
  min-width: 0;

  // Increase padding for larger screens
  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 1rem 1.5rem;
  };
`;

export const MobileContent = styled.div`
  display: flex;
  gap: 2px;
`;

export const ParagraphUnitContainer = styled.div`
  padding-bottom: 1.5px;
  padding-left: 1.5px;
  display: flex;
  align-items: flex-end;
`;
